module.exports = __webpack_public_path__ + "img/1.986d5ea0.jpg";